"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.CheckboxField = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _formik = require("formik");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _theme = require("../../constants/theme");
var _createBorderCss = _interopRequireDefault(require("../../utils/createBorderCss"));
var _Label = require("../primitive/Label");
var _ErrorMessage = _interopRequireDefault(require("./ErrorMessage"));
var _excluded = ["value", "error", "children"],
  _excluded2 = ["name", "validate"];
var Checkbox = function Checkbox(_ref) {
  var value = _ref.value,
    error = _ref.error,
    children = _ref.children,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var hasError = !!error;
  return /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement(Container, {
    hasError: hasError
  }, /*#__PURE__*/_react["default"].createElement(HiddenCheckbox, Object.assign({
    checked: !!value,
    value: value
  }, props, {
    type: "checkbox"
  })), /*#__PURE__*/_react["default"].createElement(StyledCheckbox, {
    hasError: hasError
  }, /*#__PURE__*/_react["default"].createElement(Icon, null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1 4.95l4.786 4.786L13.833 1.5"
  }))), /*#__PURE__*/_react["default"].createElement(StyledLabel, {
    htmlFor: props.id
  }, children)), error && /*#__PURE__*/_react["default"].createElement(_ErrorMessage["default"], null, error));
};
var CheckboxField = exports.CheckboxField = function CheckboxField(_ref2) {
  var name = _ref2.name,
    validate = _ref2.validate,
    props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  var _useField = (0, _formik.useField)({
      name: name,
      validate: validate
    }),
    _useField2 = (0, _slicedToArray2["default"])(_useField, 2),
    field = _useField2[0],
    _useField2$ = _useField2[1],
    touched = _useField2$.touched,
    error = _useField2$.error;
  return /*#__PURE__*/_react["default"].createElement(Checkbox, Object.assign({
    error: touched && error ? error : undefined
  }, props, field));
};
var Icon = _styledComponents["default"].svg.withConfig({
  displayName: "Checkbox__Icon",
  componentId: "sc-5a3yyj-0"
})(["fill:none;stroke:white;stroke-width:2px;width:15px;height:12px;"]);
var HiddenCheckbox = _styledComponents["default"].input.withConfig({
  displayName: "Checkbox__HiddenCheckbox",
  componentId: "sc-5a3yyj-1"
})(["position:absolute;left:14px;bottom:0;border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:1px;"]);
var StyledLabel = (0, _styledComponents["default"])(_Label.Label).attrs(function () {
  return {
    variant: 'regular'
  };
}).withConfig({
  displayName: "Checkbox__StyledLabel",
  componentId: "sc-5a3yyj-2"
})(["margin-left:1rem;font-weight:400;user-select:none;", ":disabled ~ &{color:", ";}"], HiddenCheckbox, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.neutral['30'];
});
var StyledCheckbox = _styledComponents["default"].div.withConfig({
  displayName: "Checkbox__StyledCheckbox",
  componentId: "sc-5a3yyj-3"
})(["display:inline-flex;align-items:center;justify-content:center;min-width:25px;height:25px;background:", ";border-radius:4px;transition:all 0.15s;border:none;", " --border-color:", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.neutral['0'];
}, (0, _createBorderCss["default"])('2px'), function (_ref5) {
  var theme = _ref5.theme,
    hasError = _ref5.hasError;
  return !hasError ? theme.colors.neutral['20'] : theme.colors.negative['50'];
});
var Container = _styledComponents["default"].div.withConfig({
  displayName: "Checkbox__Container",
  componentId: "sc-5a3yyj-4"
})(["display:flex;align-content:center;vertical-align:middle;cursor:default;position:relative;", "{visibility:hidden;}", ":focus + ", "{--border-color:", ";}", ":hover + ", "{--border-color:", ";}", ":checked + ", "{background:", ";--border-color:", ";", "{visibility:visible;}}", ":disabled + ", "{--border-color:", ";cursor:not-allowed;}", ":checked:disabled + ", "{background:", ";}"], Icon, HiddenCheckbox, StyledCheckbox, function (_ref6) {
  var theme = _ref6.theme;
  return (0, _theme.getAssignmentColor)(theme, theme.colorAssignments.input);
}, HiddenCheckbox, StyledCheckbox, function (_ref7) {
  var theme = _ref7.theme,
    hasError = _ref7.hasError;
  return !hasError ? (0, _theme.getAssignmentColor)(theme, theme.colorAssignments.input) : theme.colors.negative['50'];
}, HiddenCheckbox, StyledCheckbox, function (_ref8) {
  var theme = _ref8.theme,
    hasError = _ref8.hasError;
  return !hasError ? (0, _theme.getAssignmentColor)(theme, theme.colorAssignments.input) : theme.colors.negative['50'];
}, function (_ref9) {
  var theme = _ref9.theme,
    hasError = _ref9.hasError;
  return !hasError ? (0, _theme.getAssignmentColor)(theme, theme.colorAssignments.input) : theme.colors.negative['50'];
}, Icon, HiddenCheckbox, StyledCheckbox, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.neutral['30'];
}, HiddenCheckbox, StyledCheckbox, function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.neutral['30'];
});
var _default = exports["default"] = Checkbox;
//# sourceMappingURL=Checkbox.js.map